import { Trans, TransTokens, UserServiceContext } from "@citychallenge/core";
import { FC, useContext } from "react";

import styles from "./error-auth.module.scss";

const tokens = TransTokens.create({
  loginPage: "Go to the login page",
});

export interface ErrorAuthProps {}

export const ErrorAuth: FC<ErrorAuthProps> = () => {
  const userService = useContext(UserServiceContext);

  async function onLoginClick() {
    await userService.logout();
  }

  if (!userService) return null;

  return (
    <div className={styles.login} onClick={onLoginClick}>
      <Trans>{tokens.loginPage}</Trans>
    </div>
  );
};
